import { createFileRoute } from "@tanstack/react-router"
import StaffReviewWorkspace from "@/routes/-pages/StaffReviewWorkspace"
import { validateInstructorSectionSearch } from "@/utils/instructorSectionSearch"

export const Route = createFileRoute(
  "/instructor/course/$courseId/assessment/$assessmentId/staff-review/team/$revieweeTeamId",
)({
  validateSearch: validateInstructorSectionSearch,
  component: StaffReviewTeamWorkspaceRoute,
})

function StaffReviewTeamWorkspaceRoute() {
  const { courseId, assessmentId, revieweeTeamId } = Route.useParams()
  const { sectionId } = Route.useSearch()

  return (
    <StaffReviewWorkspace
      courseId={courseId}
      assessmentId={assessmentId}
      targetId={revieweeTeamId}
      targetType="team"
      sectionId={sectionId}
    />
  )
}
